import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo() {
  const route = useRoute()
  const brand = (route.query.brand as string) || ''
  const method = (route.query.method as string) || ''
  const ingredient = (route.query.ingredient as string) || ''
  const category = (route.query.category as string) || ''
  const globalStore = useGlobalStore()

  const title = `恆食堂｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.recipe
  const url = `${import.meta.env.VITE_DOMAIN}/hence/recipe`
  globalStore.setBreadcrumbs([{ title: '恆食堂', isActive: true, url: '/hence/recipe' }])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })
  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '恆食堂',
            item: url
          }
        ]
      }
    ]
  })
}
